// extracted by mini-css-extract-plugin
module.exports = {"tabListA":"tabListA_tabListA__LsVG3"};